import { Component } from '@angular/core';
import { GridViewProductCard, ProductGridViewComponent } from 'gung-standard';
import { catchError, first, forkJoin, of } from 'rxjs';

@Component({
  selector: 'otto-olsen-product-cross-reference-list-view',
  templateUrl: './otto-olsen-product-cross-reference-list-view.component.html',
  styleUrl: './otto-olsen-product-cross-reference-list-view.component.scss'
})
export class OttoOlsenProductCrossReferenceListViewComponent extends ProductGridViewComponent {
  protected subscribeToProducts() {
    if (!this.oldFlow || !this.currentFlow || this.oldFlow.id !== this.currentFlow.id) {
      // remove cached data;
      this.keyedMapData = {};
      this.oldFlow = this.currentFlow;
    }
    const newIds = this.data.map(p => p.id).filter(id => !Object.keys(this.keyedMapData).includes(id));
    if (newIds.length === 0) {
      this.readMappedDataFromCache();
      return;
    }

    const subscription = forkJoin([
      of(this.data),
      this.priceService.getCurrentCustomerPrices(newIds.filter(id => !this.data.find(p => p.id === id).extra?._nonJeevesProduct)).pipe(first(), catchError(() => of([]))),
      this.gungFlowService.getSelectedFlow().pipe(first())
    ])
      .pipe(first())
      .subscribe(([productData, prices, flow]) => {
        let avs = [];
        if (this.isAnonymous) {
          this.includeAvailability = this.gungAnonymousConfigService.showAnonymousAvailabilities && (flow.useAvailabilities || flow.requireAvailability);
        } else {
          this.includeAvailability = flow.useAvailabilities || flow.requireAvailability;
        }
        if (this.includeAvailability) {
          avs = newIds.map(id => this.getProductAvailability(this.data.find(product => product.id === id)));
        }

        this.keyedMapData = {
          ...this.keyedMapData,
          ...newIds.reduce((acc, curr) => {
            const product = productData.filter(p => p && p.id === curr)[0];

            if (!product) {
              this.findError = true;
              this.errorMessage += 'No product found. ';
              throw new Error('No product found');
            }

            const price = prices.filter(p => p && p.productId === curr)[0];

            const av = avs.filter(p => p && p.productId === curr)[0];

            const item: GridViewProductCard = this.mapItem(curr, product, price, av);
            return {
              ...acc,
              [curr]: item
            };
          }, {})
        };
        this.readMappedDataFromCache();
      });
    this.subscriptions.push(subscription);
  }
}
